const PlayIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		{...props}
	>
		<path d="M12 7L4.5 11.3301L4.5 2.66987L12 7Z" fill="currentColor"/>
	</svg>
)

export default PlayIcon